import React, { Component, Suspense } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import * as apiActions from '../actions/apiActions';
import * as configActions from '../actions/configActions';
import * as eventsActions from '../actions/eventsActions';
import Entries from '../components/Entries';
import InfiniteScrollContainer from '../containers/InfiniteScrollContainer';
import EventsContainer from '../containers/EventsContainer';
import UpdateButton from '../components/UpdateButton';
import Editor from '../components/Editor';

class AppContainer extends Component {
	constructor() {
		super();
		this.eventsContainer = document.getElementById( 'liveblog-key-events' );
	}

	componentDidMount() {
		const { loadConfig, getEntries, getEvents, startPolling } = this.props;
		loadConfig( window.liveblog_settings );
		getEntries( 1, window.location.hash );
		// Don't poll if the liveblog is archived - there won't be new entries
		if ( window.liveblog_settings.state !== 'archive' ) {
			startPolling();
		}
		if ( this.eventsContainer ) {
			getEvents();
		}
	}

	render() {
		const {
			minPage,
			loading,
			entries,
			polling,
			mergePolling,
			getEntriesPaginated,
			config,
			total,
		} = this.props;
		const canEdit = config.is_liveblog_editable === '1';

		return (
			<div style={ { position: 'relative' } }>
				{ /* minPage, not page: with infinite scroll `page` climbs as older pages
				    are appended, which would tear the editor away mid-compose. */ }
				{ minPage === 1 && canEdit && (
					<Suspense fallback={ <div>Loading editor...</div> }>
						<Editor isEditing={ false } />
					</Suspense>
				) }
				<UpdateButton
					polling={ polling }
					click={ () => mergePolling() }
				/>
				{ /* With the pagination bar gone, a reader who jumped to a key event
				    (minPage > 1) needs a way back up — new entries only ever offer
				    one when they happen to arrive. Same action as upstream's First. */ }
				{ minPage > 1 && (
					<div className="liveblog-back-to-latest">
						<button
							className="liveblog-btn liveblog-back-to-latest-btn"
							onClick={ () => getEntriesPaginated( 1, 'first' ) }
						>
							&laquo; Back to latest updates
						</button>
					</div>
				) }
				{ canEdit && (
					<div className="liveblog-updates-count">
						Updates: { total }
					</div>
				) }
				<Entries loading={ loading } entries={ entries } />
				<InfiniteScrollContainer />
				{ this.eventsContainer && (
					<EventsContainer
						container={ this.eventsContainer }
						title={ this.eventsContainer.getAttribute(
							'data-title'
						) }
					/>
				) }
			</div>
		);
	}
}

AppContainer.propTypes = {
	loadConfig: PropTypes.func,
	getEntries: PropTypes.func,
	getEvents: PropTypes.func,
	startPolling: PropTypes.func,
	api: PropTypes.object,
	entries: PropTypes.array,
	minPage: PropTypes.number,
	loading: PropTypes.bool,
	polling: PropTypes.array,
	mergePolling: PropTypes.func,
	getEntriesPaginated: PropTypes.func,
	config: PropTypes.object,
	total: PropTypes.number,
};

const mapStateToProps = ( state ) => ( {
	minPage: state.pagination.minPage,
	loading: state.api.loading,
	// No slice to entries_per_page here: infinite scroll accumulates several
	// pages in the entry map, and capping it would render only the first page.
	entries: Object.keys( state.api.entries ).map(
		( key ) => state.api.entries[ key ]
	),
	polling: Object.keys( state.polling.entries ),
	config: state.config,
	total: state.pagination.total,
} );

const mapDispatchToProps = ( dispatch ) =>
	bindActionCreators(
		{
			...configActions,
			...apiActions,
			...eventsActions,
		},
		dispatch
	);

export default connect( mapStateToProps, mapDispatchToProps )( AppContainer );
